function omit(obj, ...values) {
  const newObject = Object.assign({}, obj);
  for (const key of values)
    delete newObject[key];
  return newObject;
}
export {
  omit
};
